module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The River Below")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', [_vm._v("A Selection of Recent Titles by Bonnie Hearn Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("The Kit Doyle mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("IF ANYTHING SHOULD HAPPEN *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("GOODBYE FOREVER *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("I WISH YOU MISSED ME *")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("The Star Crossed series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("ARIES RISING")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("TAURUS EYES")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("GEMINI NIGHT")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('em', [_vm._v("* available from Severn House")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11794cbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/alsoby.vue
// module id = 63
// module chunks = 0